export default {
    APPROXIMATE_UNITS_WARNING: 'Мы указали примерные габариты груза, если они не верны, пожалуйста, исправьте их',
    NO_SELECTED_LOCATION_ON_MAP: 'Сначала выберите точку на карте!',
    REALLY_WANT_TO_REMOVE_CARGO: 'Вы действительно хотите удалить груз?',
    SOCIAL_AUTH_IMPOSSIBLE: 'Авторизация через соц. сети невозможна',
    SOCIAL_AUTH_ERROR: 'Не удалось войти через выбранную социальную сеть!',
    PHOTO_SIZE_LIMIT_EXCEEDED: 'Фото не может быть больше 10 мегабайт!',
    PHOTO_WRONG_FORMAT: 'Неверный формат фото!',
    SOMETHING_WENT_WRONG: 'Что-то пошло не так! Попробуйте еще разок',
    EDIT_ORDER_WARNING: 'Внимание! Цены, которые указывали перевозчики до ваших изменений, могут быть теперь не точны. Перевозчикам будет отправлено уведомление о изменениях',
    YOU_HAVE_NO_RIGHTS_TO_EDIT_ORDER: 'У вас нет прав на редактирование этой заявки!',
    SORRY_YOU_CAN_NOT_BE_HERE: 'Извините, но вам сюда нельзя',
    WARNING_RETURN_TO_CATEGORY_SELECTION: 'Указанные вами грузы будут потеряны! Все равно перейти к выбору категории?',
};



// WEBPACK FOOTER //
// ./client/lang/ru/warnings.js